import { Outlet, useParams } from "react-router-dom"
import NotFound from "../../screens/NotFound";

export const CuratorGuard = () => {
  const { type } = useParams();

  if (type !== 'room' && type !== 'project' && type !== 'builder') return <NotFound />

  return <Outlet />
}